import { makeStyles } from 'tss-react/mui'

export const useCritiqueStyles = makeStyles<
  void,
  'mainContent' | 'sidebarV2' | 'typographySubhead' | 'typographyBody'
>()((theme, _, classes) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: '4.03125rem 0 0',
    [theme.breakpoints.down('lg')]: {
      padding: '2.11em 0 0',
    },
  },
  title: {
    marginBottom: '3.125rem',
    [theme.breakpoints.down('lg')]: {
      fontSize: '2.13em',
      marginBottom: '2.5rem',
    },
  },
  groupNavigation: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '1.25rem',
    lineHeight: 2.5,
    maxWidth: '18.5rem',

    '& a': {
      color: theme.palette.text.primary,
    },

    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  groupNavigationTR: {
    '& > a': {
      borderBottom: `1px solid ${theme.colors.gray['a200']}`,
      padding: '1rem 0',
    },
  },
  critiqueV1: {
    paddingBottom: 61,
  },
  critiqueV2: {
    [`& .${classes.mainContent}`]: {
      minWidth: 10,
    },
  },
  sectionScrollMargin: {
    scrollMargin: '150px',

    [theme.breakpoints.down('lg')]: {
      scrollMargin: '130px',
    },
    [theme.breakpoints.down('sm')]: {
      scrollMargin: '100px',
    },
  },
  critiqueSection: {},
  CTABannerWrapper: {
    position: 'relative',
    background: theme.colors.neutral[5],
    borderRadius: 15,
    top: 15,
  },
  CTABG: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    backgroundColor: theme.colors.blue[100],
  },
  CTABannerContent: {
    padding: '72px 0',
    zIndex: 10,
  },
  CTABannerContainer: {
    width: 640,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  sidebarV2: {
    gap: '20px',
    width: '267px',
  },
  fixedSidebar: {
    [`& .${classes.sidebarV2}`]: {
      position: 'sticky',
      top: 30,
    },
  },
  skeletonLoader: {
    backgroundColor: theme.colors.neutral[5],
    borderRadius: '4px',
    position: 'relative',
    top: -2,

    '&$skeletonLoaderWave': {
      '&::after': {
        background: `linear-gradient(90deg, transparent, ${theme.colors.neutral[15]}, transparent)`,
      },
    },
  },
  topScroll: {},
  bottomScroll: {},
  scrollProgressContainer: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '24px',
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    padding: '20px 0px',
    zIndex: 99,

    [theme.breakpoints.down('md')]: {
      position: 'fixed',
      left: 0,
      width: '100vw',
      padding: '10px 0px',
      gridGap: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      gridGap: '10px',
    },

    '&$topScroll': {
      [theme.breakpoints.up('md')]: {
        display: 'none !important',
      },
    },
    '&$bottomScroll': {
      [theme.breakpoints.down('md')]: {
        display: 'none !important',
      },
    },
  },
  critiqueSidebarLeftInner: {},
  critiqueSidebarRightInner: {},
  critiqueSidebarLeft: {
    [theme.breakpoints.down('lg')]: {
      display: 'none !important',
    },
  },
  critiqueSidebarRight: {
    [theme.breakpoints.down('md')]: {
      display: 'none !important',
    },
  },
  rowsContainer: {
    [theme.breakpoints.down('lg')]: {
      padding: '0 48px',
    },
  },
  critiqueFaqSection: {
    '&& h2, && h3': {
      fontFamily: 'tt-talent',
      fontWeight: 500,
    },
  },
  mainContent: {},
  contentContainer: {
    backgroundColor: theme.palette.background.default,
    marginTop: '3.125rem',
    paddingTop: '3.125rem',
    maxWidth: 'unset',

    '&$critiqueV1': {
      marginTop: 0,
      paddingTop: 0,
      flexDirection: 'row',
      gap: '61px',
    },
    '&$critiqueV2': {
      marginTop: 0,
      paddingTop: 0,
      flexDirection: 'row',
      gap: '61px',

      [theme.breakpoints.down('lg')]: {
        gap: '48px',
      },
      [theme.breakpoints.down('md')]: {
        marginTop: '100px',
      },
    },
  },
  critiqueResultsContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 60px)',
    },
    '& .MuiBox-root': {
      [theme.breakpoints.down('lg')]: {
        gap: '1rem',
      },
    },
    '& textarea': {
      [theme.breakpoints.down('lg')]: {
        width: 'calc(100% - 60px) !important',
      },
    },
    [`& .${classes.typographySubhead}`]: {
      [theme.breakpoints.down('lg')]: {
        fontSize: '1.1rem',
      },
    },
  },
  resultsBanner: {
    display: 'flex',
    flexDirection: 'column',
    gap: '64px',
    backgroundColor: theme.colors.neutral[90],
  },
  critiquerAvatarImage: {
    width: 24,
    height: 24,

    [theme.breakpoints.down('md')]: {
      width: 32,
      height: 32,
    },
  },
  faqBottomText: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
  },
  resumeExampleContainer: {
    width: 200,
    height: 270,
    top: 3,
    maskImage:
      'linear-gradient(rgba(0, 0, 0, 1) 0%, rgba(0,0,0,1) 30%, rgba(0, 0, 0, 0) 50%)',

    [theme.breakpoints.down('md')]: {
      top: 10,
      width: 280,
      minHeight: 160,
      maskImage:
        'linear-gradient(rgba(0, 0, 0, 1) 0%, rgba(0,0,0,1) 70%, rgba(0, 0, 0, 0) 90%)',
    },

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minHeight: 140,
      maskImage:
        'linear-gradient(rgba(0, 0, 0, 1) 0%, rgba(0,0,0,1) 70%, rgba(0, 0, 0, 0) 90%)',
      opacity: 1,
      position: 'relative',
      top: 10,
    },
  },
  critiqueHeaderV2Container: {
    height: 180,
    backgroundColor: theme.colors.neutral[5],
    borderRadius: 12,
    flexDirection: 'row',
    padding: '32px',
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      gridGap: 20,
      height: 282,
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  contentContainerInner: {
    display: 'flex',
    flexDirection: 'row',
    padding: '0 6% 0 6%',
  },
  contentContainerInnerTR: {
    maxWidth: 'none',
  },
  contentfulBox: {
    flexDirection: 'column',
  },
  browsePackagesSection: {
    display: 'none',

    [theme.breakpoints.down('lg')]: {
      padding: '20px 24px 25px 24px',
      left: 0,
      bottom: 0,
      width: '100%',
      display: 'flex',
      position: 'fixed',
      zIndex: 99,
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
      backdropFilter: 'blur(4px)',
    },
  },
  skeletonLoaderWave: {},
  skeletonAuthorHeader: {
    marginLeft: 2,
    top: -4,
  },
  skeletonAuthorHeaderHideSm: {
    [theme.breakpoints.down('md')]: {
      display: 'none !important',
    },
  },
  skeletonMarginTop: {
    marginTop: 30,
  },
  progressBar: {
    backgroundColor: `${theme.colors.neutral[15]} !important`,
  },
  mainButtonSmallMd: {},
  mainButton: {
    fontSize: 19,
    lineHeight: '24px',
    padding: '12px 24px',
    width: 'fit-content',
    fontFamily: 'tt-talent',
    fontWeight: 500,
    borderRadius: '4px',
    letterSpacing: '0.2px',
    textWrap: 'wrap',

    '&:focus': {
      outline: 'none',
    },

    '&$mainButtonSmallMd': {
      [theme.breakpoints.down('lg')]: {
        fontSize: 16,
        lineHeight: '20px',
      },
    },
  },
  mainButtonSmall: {
    fontSize: 16,
    padding: '8px 12px',
    fontFamily: 'tt-talent',
    letterSpacing: '0.2px',
    width: 'fit-content',
    fontWeight: 400,
    borderRadius: '4px',

    '&:focus': {
      outline: 'none',
    },
  },
  infoBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 12,
    padding: '20px 32px 20px 20px',
    borderRadius: 12,

    background: theme.colors.amber[10],
  },
  tight: {},
  bottomPadding: {},
  outlinedContainer: {
    border: `1px solid ${theme.colors.neutral[20]}`,
    borderRadius: 12,
    padding: 32,

    '&$tight': {
      padding: '24px 20px',
    },
    '&$bottomPadding': {
      padding: '32px 32px 70px 32px',
    },
  },
  testimonialSlides: {
    '& h5': {
      textTransform: 'none',
      fontSize: 18,
      fontWeight: 400,
      lineHeight: '22px',
      color: theme.colors.neutral[90],
    },
    '& h6': {
      fontSize: 18,
      lineHeight: '22px',
      color: theme.colors.neutral[50],
      fontWeight: 400,
      textTransform: 'none',
    },
  },
  priceDisclaimer: {
    background: theme.colors.neutral[5],
    padding: '16px 20px',
  },
  sellingPoint: {
    alignItems: 'flex-start',
    padding: 0,
  },
  listItem: {
    '&&': {
      margin: '0.15rem',
      lineHeight: '1.25rem',
    },
  },
  listItemIcon: {
    minWidth: '1.45rem',
  },
  listItemIcon2: {
    minWidth: '5px !important',
  },
  icon: {
    marginRight: '.1rem !important',
    width: 'auto',
    top: -2,
    position: 'relative',

    '&$neutral': {
      color: theme.colors.neutral[20],
    },
  },
  nextStepsMainContainer: {
    background: theme.colors.neutral[5],
    borderRadius: 12,
    padding: '4px 24px 24px 24px',

    width: 400,
    [theme.breakpoints.down('lg')]: {
      width: 250,
    },
  },
  singlePriceColumns: {
    flexDirection: 'row',
    gridGap: '12px',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gridGap: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      gridGap: '8px',
    },
  },
  priceColumn: {
    width: '100%',
    borderRadius: 24,

    [theme.breakpoints.up('xs')]: {
      borderRadius: '8px',
    },
  },
  pricingMainContainer: {
    background: theme.colors.neutral[5],
    padding: '16px 24px 32px 24px',
    borderRadius: 12,
    width: 270,
  },
  priceHeaderText: {
    flexDirection: 'column',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'row-reverse',
      justifyContent: 'left',
      fontSize: 18,
      lineHeight: '22px',
    },
  },
  priceDescription: {
    [theme.breakpoints.down('md')]: {
      textAlign: 'left',
    },
  },
  getExpertButton: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
  },
  pricingArrowContainer: {
    position: 'absolute',
    right: 0,
    top: -10,
  },
  pricingArrowToggleOpen: {
    transform: 'rotate(180deg) !important',
  },
  pricingArrowToggle: {
    fontSize: 23,
    fontWeight: 800,
    color: theme.colors.blue[50],
    display: 'none',
    transform: 'rotate(0deg)',
    transition: 'transform 0.15s ease-in-out',
    transformOrigin: 'center 13px',

    [theme.breakpoints.down('md')]: {
      display: 'inline-block',
    },
  },
  hidePrice: {},
  priceColumnContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    height: 'fit-content',
    marginTop: 15,
  },
  mobileTestimonials: {
    display: 'none !important',
    [theme.breakpoints.down('md')]: {
      display: 'flex !important',
    },
  },
  priceSeparator: {
    display: 'none',

    [theme.breakpoints.down('md')]: {
      display: 'inline-block',
      fontSize: 32,
      lineHeight: '22px',
      fontWeight: 500,
    },
  },
  priceName: {
    fontFamily: 'tt-talent',

    [theme.breakpoints.down('md')]: {
      display: 'inline-block',
      fontSize: 18,
      lineHeight: '22px',
      fontWeight: 500,
    },
  },
  priceHeaderValue: {
    fontSize: 32,
    lineHeight: '36px',
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',

    [theme.breakpoints.down('md')]: {
      display: 'inline-block',
      fontSize: 18,
      lineHeight: '22px',
      fontWeight: 500,
    },
  },
  nextStepSpacingHeader: {
    padding: '20px 0px',
  },
  nextStepSpacingItem: {
    padding: '16px 0px 0px 24px',
  },
  nextStepContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
  },
  textLines: {
    display: 'inline',
  },
  textLinesSpaced: {
    [`& .${classes.typographyBody}`]: {
      marginRight: 4,
    },
  },
  cursorHelp: {
    cursor: 'help',
  },
  textLineText: {
    display: 'inline',
    marginRight: '4px !important',
  },
  infoBoxText: {
    color: theme.colors.amber[90],
  },
  containerRawData: {
    background: theme.colors.neutral[5],
  },
  critiqueMainContent: {
    flexGrow: 1,
    width: '100%',
  },
  critiqueSidebar: {
    width: 405,
  },
  sidebarFixed: {
    position: 'fixed',
    top: 0,
    right: 0,
  },
  successStoryItem: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: '24px',
    borderRadius: 12,
    border: `1px solid ${theme.colors.neutral[20]}`,
  },
  majorIssuesV2: {},
  majorIssuesContainer: {
    borderRadius: 12,
    border: `1px solid ${theme.colors.neutral[20]}`,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,

    '&$majorIssuesV2': {
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
    },
  },
  majorIssuesExpertContainer: {
    position: 'relative',
    top: -1,
    borderRadius: 0,
    borderWidth: 1,
    borderBottom: 'none',
  },
  majorIssuesPerfect: {
    background: theme.colors.blue[10],
    border: `1px solid ${theme.colors.blue[50]}`,
    borderBottom: 'none',
    '&$majorIssuesItemLastItem': {
      borderBottom: `1px solid ${theme.colors.blue[50]} !important`,
    },
  },
  majorIssuesNotPerfect: {
    border: `1px solid ${theme.colors.neutral[20]}`,
    borderBottom: 'none',
    '&$majorIssuesItemLastItem': {
      borderBottom: `1px solid ${theme.colors.neutral[20]} !important`,
    },
  },
  badgeItemsArrows: {
    display: 'none',
    position: 'absolute',
    width: '100%',
    zIndex: 10,
    top: 14,
    left: 0,
    justifyContent: 'space-between',
    pointerEvents: 'none',

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  badgeItemsHeaderContainer: {},
  badgeItemsContainer: {
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      left: 35,
      width: 'calc(100% - 70px)',
      overflowX: 'scroll',

      '&::-webkit-scrollbar': {
        display: 'none',
      },

      '&::-webkit-scrollbar-thumb': {
        display: 'none',
      },
    },
  },
  badgeItems: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'fit-content',
    },
  },
  bannerLogo: {
    position: 'absolute',
    top: 20,

    [theme.breakpoints.down('md')]: {
      display: 'none !important',
    },
  },
  active: {},
  badgeItem: {
    fontFamily: 'tt-talent',
    textAlign: 'center',
    borderRadius: 24,
    padding: '12px 10px',
    width: 116,
    backgroundColor: theme.colors.neutral[10],
    cursor: 'pointer',
    border: 'none',
    color: `${theme.colors.neutral[60]} !important`,
    fontWeight: 400,

    '&.Mui-active': {
      color: `${theme.colors.blue[50]} !important`,
      backgroundColor: theme.colors.blue[10],
    },

    '&:focus': {
      backgroundColor: theme.colors.blue[10],
    },

    '&:hover': {
      color: `${theme.colors.blue[50]} !important`,
      backgroundColor: `${theme.colors.neutral[5]} !important`,

      [theme.breakpoints.down('md')]: {
        color: `${theme.colors.neutral[60]} !important`,
        backgroundColor: `${theme.colors.neutral[10]} !important`,

        '&.Mui-active': {
          color: `${theme.colors.blue[50]} !important`,
          backgroundColor: `${theme.colors.blue[10]} !important`,
        },
      },
    },
  },
  majorIssuesItemFirstItem: {
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
  },
  majorIssuesItemLastItem: {
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    borderBottom: `1px solid ${theme.colors.blue[50]}  !important`,
  },
  majorIssuesItemContainerX: {
    paddingTop: 24,
    paddingBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  majorIssuesItemContainerY: {
    paddingLeft: 24,
    paddingRight: 24,
  },
  divider: {
    margin: '1px 0',
    backgroundColor: `${theme.colors.neutral[50]} !important`,
  },
  infoGridContainer: {
    backgroundColor: 'white',
    border: `1px solid ${theme.colors.neutral[20]}`,
    borderRadius: 12,
  },
  infoGridItemBorderBottom: {
    borderBottom: `1px solid ${theme.colors.neutral[20]}`,
  },
  infoGridItemBorderRight: {
    borderRight: `1px solid ${theme.colors.neutral[20]}`,
  },
  infoGridItem: {
    padding: 16,
  },
  infoGridItemError: {
    backgroundColor: theme.colors.red[10],
  },
  infoGridItemHeader: {
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '0.3px',
    color: theme.colors.neutral[90],
  },
  infoGridTextError: {
    textTransform: 'uppercase',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '1.8px',
    fontSize: '14px',
    color: theme.colors.red[60],
  },
  link: {
    fontSize: 19,
    color: theme.colors.blue[50],
    textDecoration: 'none',
    fontFamily: 'tt-talent',
  },
  linkSmall: {
    fontSize: 16,
    fontFamily: 'tt-talent',
    lineHeight: '20px',
    fontWeight: 500,
    padding: '8px 12px',
  },
  linkSmallLabel: {
    position: 'relative',
    top: 1,
    lineHeight: 1.2,
  },
  headerBannerFixed: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    marginBottom: 500,
  },
  headerBannerContainer: {
    padding: '10px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    background: theme.colors.blue[100],
  },
  chipListContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  gradientBarContainer: {
    padding: '24px 32px',
    borderRadius: 12,
    border: `solid 1px ${theme.colors.neutral[15]}`,
  },
  gradientBar: {
    borderRadius: 4,
  },
  gradientBarHeader: {
    flexDirection: 'row',
    gap: 1,

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      gap: 10,
    },
  },
  gradientBarBG: {
    background: theme.colors.neutral[20],
    position: 'absolute',
    right: 0,
    borderRadius: 4,

    [theme.breakpoints.down('lg')]: {
      borderRadius: 0,
      height: '20px !important',
      top: '0px !important',
    },
  },
  gradientBarNeedle: {
    background: 'white',
    border: `1px solid ${theme.colors.neutral[20]}`,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
    borderRadius: 30,
    position: 'absolute',
    zIndex: 10,

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  gradientBarNeedleInner: {
    borderRadius: 30,
  },
  chipList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
  chip: {
    borderRadius: 4,
    padding: '6px 10px',
  },
  doesLookLikeYouContainer: {
    padding: '20px 32px 20px 20px',
    background: theme.colors.blue[10],
  },
  neutralChip: {
    background: theme.colors.neutral[10],
    color: theme.colors.neutral[90],
  },
  blueChip: {
    background: theme.colors.blue[10],
    color: theme.colors.blue[60],
  },
  typographyHeaderTitle: {
    fontSize: 39,
    lineHeight: '40px',
    color: theme.colors.neutral[90],
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',
  },
  typographyPowered: {
    fontSize: 16,
    lineHeight: '20px',
    color: theme.colors.neutral[60],
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',
  },
  typographyToggleSmall: {
    [theme.breakpoints.down('lg')]: {
      fontSize: '14px !important',
      lineHeight: '16px !important',
    },
  },
  typographyBody: {
    fontSize: 19,
    lineHeight: '24px',
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',
    margin: 0,
  },
  typographyBody2: {
    fontSize: 19,
    lineHeight: '24px',
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',
    margin: 0,
    color: theme.colors.neutral[60],
  },
  typographyMobileBody: {
    fontSize: 18,
    lineHeight: '22px',
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',
    margin: 0,
  },
  typographySubhead: {
    fontSize: 23,
    lineHeight: '28px',
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',
  },
  typographyCaption: {
    fontSize: 16,
    lineHeight: '20px',
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',
  },
  typographyHeader2: {
    fontSize: 33,
    lineHeight: '36px',
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',
  },
  typographyHeaderMobile: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
  typographyTrimString: {
    [theme.breakpoints.down('sm')]: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      width: 10,
    },
  },
  typographyHeader2Desktop: {
    fontSize: 43,
    lineHeight: '43px',
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',

    '&$typographySmallMd': {
      [theme.breakpoints.down('md')]: {
        fontSize: 31,
        lineHeight: '31px',
      },
    },
  },
  typographyHeader3Desktop: {
    fontSize: 24,
    lineHeight: '28px',
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',

    '&$typographySmallMd': {
      [theme.breakpoints.down('lg')]: {
        fontSize: 21,
        lineHeight: '24px',
      },
    },
  },
  typographySmallMd: {},
  rawDataHeaderContainer: {
    display: 'inline',
  },
  typographyRawDataHeader: {
    fontSize: 33,
    lineHeight: '36px',
    fontWeight: 500,
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',
    display: 'inline',
  },
  typographyRawDataDescription: {
    fontSize: 18,
    lineHeight: '28px',
    fontWeight: 400,
    fontFamily: 'ibm-plex',
    letterSpacing: 'normal',
  },
  typographyRawDataSub: {
    fontSize: 18,
    lineHeight: '28px',
    fontWeight: 400,
    fontFamily: 'tt-talent',
    letterSpacing: 'normal',
  },
  spacedLeft: {
    marginLeft: 6,
  },
  marginTop8: {
    marginTop: 8,
  },
  bold: {
    fontWeight: 500,
  },
  bolder: {
    fontWeight: 600,
  },
  italic: {
    fontStyle: 'italic',
  },
  neutral: {
    color: theme.colors.neutral[60],
  },
  neutralLight: {
    color: theme.colors.neutral[50],
  },
  orange: {
    color: theme.colors.orange[50],
  },
  textTitle: {
    display: 'block',
    marginBottom: 10,
    fontWeight: 500,
  },
  white: {
    color: '#FFF',
  },
  centerText: {
    textAlign: 'center',
  },
  fullWidthButton: {
    width: '100%',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      lineHeight: 1.5,
    },
  },
  hideMobileSm: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  priceText: {
    color: theme.colors.neutral[90],
    '&:hover': {
      color: theme.colors.neutral[90],
      textDecoration: 'none',
    },
  },
  chartContainer: {
    flexWrap: 'nowrap',

    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
  },
  priceDescriptionContainer: {
    height: 80,
    display: 'flex',
    alignItems: 'center',
    lineHeight: '20px',

    [theme.breakpoints.down('md')]: {
      height: 'auto',
    },
  },
  showMobileSm: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  sellingPointSpace: {
    gap: 4,
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    margin: '0 !important',
  },
  wrapTextSmall: {
    [theme.breakpoints.down('md')]: {
      fontSize: 17,
      whiteSpace: 'normal',
    },
  },
  floatingSelector: {
    display: 'flex',
    position: 'fixed',
    top: 10,
    left: 10,
    zIndex: 1000,
  },
  resumeExampleContainerSkeleton: {
    top: -70,
    [theme.breakpoints.down('sm')]: {
      top: 15,
    },
  },
}))
